module.exports = __webpack_public_path__ + "img/polygon-right-enable.726127e3.svg";